/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { Injectable } from '@angular/core';
import { ProxyDataService } from '@app/core/http/proxy-data.service';
import { appConstants } from '@app/common/app-constants';
import { Base64Service } from '@app/util/base64.service';

@Injectable({
  providedIn: 'root'
})
export class CustomWorkListService {
  constructor(private dataService: ProxyDataService, private base64Service: Base64Service) {}

  createCustomWorklist(worklistParams) {
    return this.dataService.create(appConstants.appURLs.customWorklist, worklistParams);
  }

  retrieveCustomWorklists() {
    return this.dataService.get(appConstants.appURLs.customWorklist);
  }

  updateCustomWorklist(worklistId, worklistParams) {
    return this.dataService.update(appConstants.appURLs.customWorklist, worklistId, worklistParams);
  }

  deleteCustomWorklist(worklistId) {
    return this.dataService.remove([appConstants.appURLs.customWorklist, worklistId].join('/'));
  }

  getCustomWorklistFilter(worklistId) {
    const filterDetailsEndpoint = [appConstants.appURLs.customWorklist, worklistId, 'worklist-filter-details'].join(
      '/'
    );
    return this.dataService.get(filterDetailsEndpoint);
  }

  getExamStatusDetails() {
    const endpoint = [appConstants.appURLs.customWorklist, 'exam-status-details'].join('/');
    return this.dataService.get(endpoint);
  }

  getExamDescriptions(searchCriteria: string, isSearchCriteriaWildCard: boolean) {
    const params = {};
    let endpoint;

    if (isSearchCriteriaWildCard) {
      params['searchPattern'] = this.base64Service.paramToBase64(searchCriteria);
      endpoint = appConstants.appURLs.procedureDescriptions;
    } else {
      params['ids'] = searchCriteria;
      endpoint = appConstants.appURLs.procedureDescriptionByIds;
    }

    return this.dataService.get(endpoint, params);
  }
}
